/* Ported from frontend/assets/js/main.js initScrollReveal() — adds .is-visible
   to .reveal elements as they scroll into view. Without this, anything using
   the prototype's .reveal class (opacity:0 by default) stays invisible. */
(function () {
  function initScrollReveal() {
    var targets = document.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window) || !targets.length) {
      targets.forEach(function (t) { t.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    targets.forEach(function (t) { observer.observe(t); });
  }

  document.addEventListener('DOMContentLoaded', initScrollReveal);
  document.addEventListener('shopify:section:load', initScrollReveal);
})();
